import { useLocation } from "react-router-dom";
// TODO: Maybe unify React-Router and Next.js Router to have the same behaviour
//  In Next.js we do not have the set. There we need to redirect manually.
/**
 * Returns ReadOnly search params
 */
export const useSearchParams = () => {
  const urlParams = useLocation().search;
  return new URLSearchParams(urlParams);
};
